import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { getFlashFreeChildCount, getTotalChildren, getTotalInfants } from 'components/SearchKit/SearchTiles/accommodations/hotelSearchTileLabelsUtils'

interface UseChildrenStayFreeParams {
  offerType: App.OfferType
  filters?: App.OfferListFilters
  capacitiesByRate: Array<Array<App.RoomCapacity>>
  includedGuestsByRate?: Array<Array<App.PackageRoomIncludedGuests>>
}

function useChildrenStayFree({ offerType, filters, capacitiesByRate, includedGuestsByRate }: UseChildrenStayFreeParams) {
  const intl = useIntl()

  const totalChildrenAndInfants = useMemo(
    () => getTotalChildren(filters) + getTotalInfants(filters),
    [filters],
  )

  const freeStayLabel = useMemo(() => {
    const freeCount = getFlashFreeChildCount({ offerType, filters, capacitiesByRate, includedGuestsByRate })
    if (freeCount === 0) return undefined

    const allCovered = freeCount >= totalChildrenAndInfants

    if (allCovered) {
      return intl.formatMessage(
        {
          id: 'Lf5gp9lJi7Xhg_lXiUbd',
          defaultMessage: '{count, plural, one {Your child stays free} other {Your children stay free}}',
          description: 'Label when all searched children/infants are eligible for a free stay',
        },
        { count: freeCount },
      )
    }

    return intl.formatMessage(
      {
        id: 'At1GS-n-t7FCdzfPqFo9',
        defaultMessage: '{count, plural, one {# child stays free} other {# children stay free}}',
        description: 'Label when some but not all searched children/infants are eligible for a free stay',
      },
      { count: freeCount },
    )
  }, [intl, offerType, filters, capacitiesByRate, includedGuestsByRate, totalChildrenAndInfants])

  return { freeStayLabel }
}

export default useChildrenStayFree
